module.exports = __webpack_public_path__ + "static/media/patients-template.142a3cb7.csv";